import React from 'react';

import { css } from '@emotion/core';
import styled from '@emotion/styled';
import Colors from '@theme/colors';

const FormButton = (props: any) => {
  return (
    <button {...props} data-i={props.dataI}>
      {props.children}
    </button>
  );
};

const FormButtonSTyle = () => css`
  background: ${Colors.science37};
  border: 0;
  border-radius: 3px;
  color: ${Colors.neutral0};
  font-size: 1.2em;
  font-weight: 400;
  height: 60px;
  width: 47%;

  &:hover {
    cursor: pointer;
  }
`;

const FormButtonStyled = styled(FormButton)`
  ${FormButtonSTyle}
`;

export default FormButtonStyled;
